import { Injectable } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { NotificationType } from '../constants/notification-type.enum';
import { ActionState } from '../constants/action-state.enum';
import { CommonInits } from '../constants/common-init';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private toastService: ToasterService) { }

    open(options: {type?: NotificationType | string | any, title?: string | any, body?: string | any}) {
        this.toastService.pop(options.type || 'success', options.title, options.body);
    }

    showPerformSuccessOneRecord(actionState: ActionState) {
        const toastNotify = CommonInits.showToastsMesg(actionState, {multiple: false});
        this.open(toastNotify);
    }

    showPerformSuccessManyRecord(actionState: ActionState, noOfSuccess: any) {
        const input = {
            multiple: true,
            noOfSuccess
        };
        const toastNotify = CommonInits.showToastsMesg(actionState, input);
        this.open(toastNotify);
    }
}
